import React, { useState, useEffect } from 'react';
import { IPropertyWizardInput } from './NewPropertyWizard';
// import styles from './Publish.scss';
import styles from './NewPropertyWizard.scss';
import ButtonRound from '../ButtonRound';
import Modal from './SmsDoi/Modal';
import Owner from '../../utils/Owner';
import useUser from '../../stores/useUser';
import { IContact } from '../../utils/JsonApiRequest';

export interface IPublishProps extends IPropertyWizardInput {
}

const Publish: React.FC<React.PropsWithChildren<IPublishProps>> = ({ step = null, data = null, onChange = () => { }, isLoading = false, open }) => {
    const [user] = useUser();
    const [contact, setContact] = useState({ field_address: {} } as IContact);
    const [isOpen, setIsOpen] = useState(open === true);
    const [moderationState, setModerationState] = useState('');

    useEffect(() => {
        Owner(user.id)
            .getContact()
            .then((data) => {
                setContact(data);
            });
    }, []);

    const handleChange = (val: string) => {
        onChange(step.name, val);
    };

    const handleOpen = (val: string) => {
        setModerationState(val);
        setIsOpen(true);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    return (
        <div className={styles.publish}>
            <p><b>Dein Inserat ist nur noch einen Klick entfernt!</b></p><br />
            <p><b>Hinweis:</b> Inseriere exklusiv, um die Qualität Deiner Anfragen zu erhöhen. So erhältst Du nur Anfragen unserer Premium-Kund:innen.</p><br />
            <p>Natürlich kannst Du auch auf die Vorteile des exklusiven Uploads verzichten und Deine Immobilie auch regulär veröffentlichen und auf anderen Plattformen hochladen.</p>
            {contact.phone_verified ?
                <div>
                    <div className={styles.publishAction}>
                        <ButtonRound
                            type="submit"
                            variant="link"
                            disabled={isLoading}
                            isLoading={data.moderation_state === 'published' && isLoading}
                            onClick={() => {
                                handleChange('published');
                            }}
                        >
                            regulär inserieren
                        </ButtonRound>
                        <ButtonRound
                            onClick={() => {
                                handleChange('exclusively_published');
                            }}
                            disabled={isLoading}
                            type="submit"
                            size="extraLarge"
                            isLoading={data.moderation_state === 'exclusively_published' && isLoading}
                        >
                            Jetzt exklusiv inserieren
                        </ButtonRound>
                    </div>
                    <div className={styles.previewAction}>
                        <ButtonRound
                            onClick={() => { }}
                            size="extraLarge"
                            color="primary"
                            type="submit"
                            variant="outlined"
                            isLoading={isLoading && (!step.isLast || data.moderation_state === 'draft')}
                        >
                            Zur Vorschau
                        </ButtonRound>
                    </div>
                </div>
                :
                <div>
                    <div className={styles.publishAction}>
                        <ButtonRound
                            type="button"
                            variant="link"
                            disabled={isLoading}
                            isLoading={data.moderation_state === 'published' && isLoading}
                            onClick={() => {
                                handleOpen('published');
                            }}
                        >
                            regulär inserieren
                        </ButtonRound>
                        <ButtonRound
                            onClick={() => {
                                handleOpen('exclusively_published');
                            }}
                            disabled={isLoading}
                            type="button"
                            size="extraLarge"
                            isLoading={data.moderation_state === 'exclusively_published' && isLoading}
                        >
                            Jetzt exklusiv inserieren
                        </ButtonRound>
                    </div>
                    <div className={styles.previewAction}>
                        <ButtonRound
                            onClick={() => {
                                handleOpen('draft');
                            }}
                            size="extraLarge"
                            color="primary"
                            type="button"
                            variant="outlined"
                            isLoading={isLoading && (!step.isLast || data.moderation_state === 'draft')}
                        >
                            Zur Vorschau
                        </ButtonRound>
                    </div>
                </div>
            }
            <Modal
                open={isOpen}
                onClose={handleClose}
                step={step}
                data={data}
                onChange={onChange}
                isLoading={isLoading}
                moderationState={moderationState}
            >
            </Modal>
        </div>
    );
};

export default Publish;